import React from 'react';
import { useWindowManager } from '@/contexts/WindowManager';
import { Window } from '@/components/ui/window';
import { MobileWindowSwitcher } from '@/components/ui/mobile-window-switcher';

export const WindowContainer: React.FC = () => {
  const { windows, isMobile } = useWindowManager();
  
  // Sort windows by z-index for proper layering
  const sortedWindows = [...windows].sort((a, b) => a.zIndex - b.zIndex);

  return (
    <>
      {/* Mobile window switcher */}
      {isMobile && <MobileWindowSwitcher />}
      
      {/* Render windows */}
      {sortedWindows.map((window) => (
        <Window key={window.id} window={window} />
      ))}
    </>
  );
};